import * as React from "react";
import { connect } from "react-redux";

class SecuredComponent extends React.Component {

    isVisible() {
        if (this.props.unlimitedAccess || this.props.readOnlyAccess) return true;
        const myRights = this.props.levels.filter(x => x.role === this.props.role);
        const demandRights = this.props.levels.filter(x => x.role === this.props.readSecurityLevel);
        if (myRights[0].securityLevel >= demandRights[0].securityLevel) return true;
        return false;
    }

    isReadOnly() {
        if (this.props.unlimitedAccess) return false;
        const myRights = this.props.levels.filter(x => x.role === this.props.role);
        const demandRights = this.props.levels.filter(x => x.role === this.props.editSecurityLevel);
        if (demandRights.length && myRights[0].securityLevel >= demandRights[0].securityLevel) return false;
        return true;
    }

    render() {
        const visi = this.isVisible();
        if (!visi) return null;
        const childrenWithProps = React.Children.map(this.props.children, child =>
            React.cloneElement(child, {
                isreadonly: this.isReadOnly() ? 1 : 0
            })
        );
        return (
            [...childrenWithProps]
        );
    }
}

const mapStateToProps = state => ({
    levels: state.security.securityLevels,
    role: state.user.role
})

export default connect(mapStateToProps, null)(SecuredComponent)


// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/SecuredComponent.js